import './layout.pcss';
import angular from 'angular';
import 'angular-i18n/angular-locale_hu-hu';
import '../../modules/M10-tab/M10-tab';

const MODULE_NAME = 'AALT-app';

export default angular.module(MODULE_NAME, window.dependencies).name;



// WEBPACK FOOTER //
// ../source/layouts/AALT/layout.js